import React from 'react';
import { IconProps } from '../IconProps';

export const ConfigurationIcon: React.FC<IconProps> = ({
	width = 20,
	height = 20,
	stroke = 'currentColor',
	className,
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		className={className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.06772 7.81284C6.27435 8.04099 6.56782 8.17115 6.87564 8.17115C7.18345 8.17115 7.47692 8.04099 7.68355 7.81284L8.20605 7.2295C8.51474 6.88814 9.00478 6.77786 9.42995 6.95406C9.85512 7.13026 10.1235 7.55486 10.1002 8.0145L10.0611 8.79284C10.0437 9.10083 10.1585 9.40161 10.3766 9.61975C10.5948 9.83788 10.8956 9.95267 11.2036 9.93534L11.9819 9.89617C12.4418 9.87226 12.867 10.1407 13.0431 10.5662C13.2193 10.9918 13.1083 11.4821 12.7661 11.7903L12.1877 12.3128C11.9591 12.5192 11.8286 12.8128 11.8286 13.1208C11.8286 13.4287 11.9591 13.7223 12.1877 13.9287L12.7661 14.4512C13.1083 14.7594 13.2193 15.2497 13.0431 15.6753C12.867 16.1008 12.4418 16.3692 11.9819 16.3453L11.2036 16.3062C10.8959 16.2902 10.5959 16.4054 10.3781 16.6232C10.1603 16.841 10.0451 17.141 10.0611 17.4487L10.1002 18.227C10.1235 18.6866 9.85512 19.1112 9.42995 19.2874C9.00478 19.4636 8.51474 19.3534 8.20605 19.012L7.68355 18.4287C7.47692 18.2005 7.18345 18.0704 6.87564 18.0704C6.56782 18.0704 6.27435 18.2005 6.06772 18.4287L5.54522 19.012C5.23653 19.3534 4.74649 19.4636 4.32132 19.2874C3.89615 19.1112 3.62778 18.6866 3.65105 18.227L3.69022 17.4487C3.70568 17.1412 3.59029 16.8415 3.37258 16.6238C3.15488 16.4061 2.85521 16.2907 2.54772 16.3062L1.76939 16.3453C1.30974 16.3686 0.885146 16.1002 0.708944 15.6751C0.532741 15.2499 0.643026 14.7599 0.984386 14.4512L1.56355 13.9287C1.79171 13.722 1.92186 13.4286 1.92186 13.1208C1.92186 12.8129 1.79171 12.5195 1.56355 12.3128L0.984386 11.7903C0.643026 11.4816 0.532741 10.9916 0.708944 10.5664C0.885146 10.1413 1.30974 9.8729 1.76939 9.89617L2.54772 9.93534C2.85535 9.95133 3.15534 9.83611 3.37316 9.61828C3.59099 9.40046 3.70621 9.10047 3.69022 8.79284L3.65105 8.0145C3.62778 7.55486 3.89615 7.13026 4.32132 6.95406C4.74649 6.77786 5.23653 6.88814 5.54522 7.2295L6.06772 7.81284Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M6.875 14.6875C7.73794 14.6875 8.4375 13.9879 8.4375 13.125C8.4375 12.2621 7.73794 11.5625 6.875 11.5625C6.01206 11.5625 5.3125 12.2621 5.3125 13.125C5.3125 13.9879 6.01206 14.6875 6.875 14.6875Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.5322 4.16602C15.3596 4.16602 15.2197 4.30593 15.2197 4.47852C15.2197 4.6511 15.3596 4.79102 15.5322 4.79102C15.7048 4.79102 15.8447 4.6511 15.8447 4.47852C15.8447 4.30593 15.7048 4.16602 15.5322 4.16602Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.6616 1.53989C17.8926 1.44995 18.155 1.50506 18.3303 1.68037C18.5056 1.85567 18.5607 2.11803 18.4708 2.34906L18.0541 3.42072C17.9552 3.67466 18.0324 3.96344 18.2449 4.13406L19.1408 4.85406C19.3339 5.00916 19.4173 5.26372 19.3532 5.50303C19.2891 5.74233 19.0898 5.92121 18.8449 5.95906L17.7091 6.13489C17.4397 6.17608 17.2282 6.38726 17.1866 6.65656L17.0108 7.79322C16.9729 8.03805 16.7941 8.23741 16.5547 8.30148C16.3154 8.36555 16.0609 8.28222 15.9058 8.08906L15.1858 7.19322C15.0151 6.98087 14.7266 6.90336 14.4724 7.00156L13.4008 7.41823C13.1697 7.50817 12.9074 7.45306 12.7321 7.27775C12.5568 7.10244 12.5017 6.84009 12.5916 6.60906L13.0083 5.53739C13.1072 5.28345 13.03 4.99467 12.8174 4.82406L11.9216 4.10322C11.7288 3.94824 11.6457 3.69403 11.7098 3.4551C11.7739 3.21618 11.973 3.03763 12.2174 2.99989L13.3533 2.82406C13.6226 2.78227 13.834 2.57093 13.8758 2.30156L14.0516 1.16656C14.0891 0.921678 14.2678 0.722121 14.5071 0.65801C14.7464 0.593899 15.0009 0.677369 15.1558 0.870725L15.8766 1.76656C16.0474 1.97885 16.336 2.05606 16.5899 1.95739L17.6616 1.53989Z"
			stroke={stroke}
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
